import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { useConfirm } from '../components/ConfirmModal';
import {
  Building, Building2, Home, DoorOpen, DoorClosed, Bed, Bath, Toilet, ShowerHead,
  Sofa, Armchair, Coffee, Utensils, ChefHat, GlassWater, ShoppingCart, Store,
  Package, Warehouse, Truck, Car, ParkingCircle, Bike, Bus, Train, Plane,
  ArrowUpDown, ArrowUpRight, Layers, TrendingUp, MapPin, Map, Compass, Navigation, Info, HelpCircle, Bell,
  ConciergeBell, Shield, Camera, Lock, Key, Users, User, UserCheck, Briefcase,
  Laptop, Monitor, Printer, Server, HardDrive, Wrench, Hammer, Settings,
  Lightbulb, Zap, Flame, Thermometer, Droplets, Waves,
  Bluetooth, Clock, ChevronUp, ChevronDown, X, Check, Pencil, Trash2,
  Hotel, HardHat, ShoppingBag, Heart, CalendarDays, BedDouble, House,
  Calculator, UserCog, Crown, FlaskConical, Pill, Gamepad2, PartyPopper,
  Caravan, Trees, Tent, ParkingSquare, MapPinned
} from 'lucide-react';

const icons = {
  accueil: ConciergeBell,
  accueil_information: Info,
  aide: HelpCircle,
  batiment: Building,
  batiment_annexe: Building2,
  maison: Home,
  entree: DoorOpen,
  sortie: DoorClosed,
  porte: DoorClosed,
  chambre: Bed,
  chambre_hopital: Bed,
  chambre_hotel: Bed,
  salon: Sofa,
  fauteuil: Armchair,
  salle_bain: Bath,
  douche: ShowerHead,
  toilettes: Toilet,
  cafeteria: Coffee,
  restaurant: Utensils,
  cuisine: ChefHat,
  distributeur_boisson: GlassWater,
  boutique: Store,
  boutique_panier: ShoppingCart,
  archives: Package,
  entrepot: Warehouse,
  livraison: Truck,
  parking: ParkingCircle,
  garage: Car,
  velo: Bike,
  transport_bus: Bus,
  transport_train: Train,
  aeroport: Plane,
  ascenseur: ArrowUpDown,
  escaliers: ArrowUpDown,
  hotel: Hotel,
  residence: House,
  logis: BedDouble,
  rbnb: BedDouble,
  btp: HardHat,
  commerce: ShoppingBag,
  medical: Heart,
  evenementiel: CalendarDays,
  localisation: MapPin,
  plan: Map,
  orientation: Compass,
  navigation: Navigation,
  securite: Shield,
  camera: Camera,
  badge: Key,
  acces: Lock,
  reunion: Users,
  utilisateur: User,
  personnel: UserCheck,
  bureau: Briefcase,
  coworking: Laptop,
  informatique: Monitor,
  impression: Printer,
  reprographie: Printer,
  serveur: Server,
  stockage: HardDrive,
  maintenance: Wrench,
  travaux: Hammer,
  configuration: Settings,
  administration: Settings,
  direction: Crown,
  comptabilite: Calculator,
  rh: UserCog,
  responsable: UserCheck,
  infirmerie: Heart,
  laboratoire: FlaskConical,
  pharmacie: Pill,
  spa: Waves,
  salle_reception: PartyPopper,
  salle_jeux: Gamepad2,
  mobil_home: Caravan,
  emplacement: MapPinned,
  lodge: Trees,
  tente: Tent,
  place: ParkingSquare,
  formation: Lightbulb,
  electricite: Zap,
  discotheque: Zap,
  sport: Zap,
  incendie: Flame,
  temperature: Thermometer,
  eau: Droplets,
  piscine: Waves,
};

function TypeIcon({ type, size = 20, color = '#1a56db' }) {
  const Ic = icons[type] || Lock;
  return <Ic size={size} color={color} />;
}

const QbdpWatermark = () => (
  <div style={{ textAlign: 'center', marginTop: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
    <Lock size={10} color="#d1d5db" />
    <span style={{ fontSize: 10, color: '#d1d5db', fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase' }}>QBDP · Quality Badge & Digital Protocol</span>
  </div>
);

function ModalInput({ title, subtitle, icon: Icon = Building2, placeholder, defaultValue = '', confirmLabel = 'Créer', onConfirm, onCancel }) {
  const [val, setVal] = React.useState(defaultValue);
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(10,15,40,0.65)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 20, width: '100%', maxWidth: 420, boxShadow: '0 32px 80px rgba(0,0,0,0.35)', overflow: 'hidden' }}>
        <div style={{ background: 'linear-gradient(135deg, #1a56db 0%, #1648c0 100%)', padding: '32px 28px 36px', textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: 20, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
            <Icon size={30} color="white" />
          </div>
          <div style={{ fontSize: 18, fontWeight: 700, color: 'white', letterSpacing: -0.3 }}>{title}</div>
          {subtitle && <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.72)', marginTop: 6 }}>{subtitle}</div>}
        </div>
        <div style={{ padding: '24px 28px 28px' }}>
          <input autoFocus value={val} onChange={e => setVal(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && val.trim()) onConfirm(val.trim()); if (e.key === 'Escape') onCancel(); }}
            placeholder={placeholder}
            style={{ width: '100%', border: '1.5px solid #e5e7eb', borderRadius: 12, padding: '13px 16px', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
            onFocus={e => e.target.style.borderColor = '#1a56db'}
            onBlur={e => e.target.style.borderColor = '#e5e7eb'}
          />
          <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
            <button onClick={onCancel} style={{ flex: 1, padding: '12px', borderRadius: 10, border: '1.5px solid #e5e7eb', background: 'white', fontSize: 13, cursor: 'pointer', color: '#374151', fontWeight: 600 }}>Annuler</button>
            <button onClick={() => val.trim() && onConfirm(val.trim())} style={{ flex: 2, padding: '12px', borderRadius: 10, border: 'none', background: '#1a56db', color: 'white', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{confirmLabel}</button>
          </div>
          <QbdpWatermark />
        </div>
      </div>
    </div>
  );
}

function ModalConfirmAcces({ title, body, confirmLabel = 'Supprimer', confirmColor = '#dc2626', onConfirm, onCancel }) {
  const isDelete = !confirmColor || confirmColor === '#dc2626';
  const IconComp = isDelete ? Trash2 : Check;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(10,15,40,0.65)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 20, width: '100%', maxWidth: 420, boxShadow: '0 32px 80px rgba(0,0,0,0.35)', overflow: 'hidden' }}>
        <div style={{ background: isDelete ? 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)' : `linear-gradient(135deg, ${confirmColor} 0%, ${confirmColor}cc 100%)`, padding: '32px 28px 36px', textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: 20, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
            <IconComp size={30} color="white" />
          </div>
          <div style={{ fontSize: 18, fontWeight: 700, color: 'white', letterSpacing: -0.3 }}>{title}</div>
        </div>
        <div style={{ padding: '24px 28px 28px' }}>
          <div style={{ fontSize: 14, color: '#4b5563', lineHeight: 1.7, textAlign: 'center', marginBottom: 24 }}>{body}</div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button onClick={onCancel} style={{ flex: 1, padding: '12px', borderRadius: 10, border: '1.5px solid #e5e7eb', background: 'white', fontSize: 13, cursor: 'pointer', color: '#374151', fontWeight: 600 }}>Annuler</button>
            <button onClick={onConfirm} style={{ flex: 1, padding: '12px', borderRadius: 10, border: 'none', background: confirmColor, color: 'white', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{confirmLabel}</button>
          </div>
          <QbdpWatermark />
        </div>
      </div>
    </div>
  );
}

const JOURS_LABELS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

function StatCard({ value, label, color }) {
  return (
    <div style={{ background: 'white', borderRadius: 12, border: '1px solid var(--border)', padding: '20px 24px' }}>
      <div style={{ fontSize: 28, fontWeight: 800, color: color || 'var(--blue)' }}>{value}</div>
      <div style={{ fontSize: 13, color: color || 'var(--gray)', marginTop: 4 }}>{label}</div>
    </div>
  );
}

function PlageRow({ plage, idx, onUpdate, onDelete, canDelete }) {
  const joursArr = plage.jours ? plage.jours.split('') : ['L','M','M','J','V','S','D'];
  const JOURS_REF = ['L','M','M','J','V','S','D'];
  const toggleJour = (i) => {
    const newJours = joursArr.map((j, k) => k === i ? (j === '_' ? JOURS_REF[k] : '_') : j).join('');
    onUpdate({ ...plage, jours: newJours });
  };
  return (
    <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 14px', margin: '4px 0 4px 46px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 11, fontWeight: 600, color: '#1a56db', background: '#eff6ff', padding: '2px 8px', borderRadius: 10 }}>Plage {idx + 1}</span>
        <input type="time" value={plage.heure_debut || '00:00'} onChange={e => onUpdate({ ...plage, heure_debut: e.target.value })}
          style={{ border: '1px solid #e2e8f0', borderRadius: 6, padding: '3px 6px', fontSize: 12 }} />
        <span style={{ fontSize: 12, color: '#6b7280' }}>→</span>
        <input type="time" value={plage.heure_fin || '23:59'} onChange={e => onUpdate({ ...plage, heure_fin: e.target.value })}
          style={{ border: '1px solid #e2e8f0', borderRadius: 6, padding: '3px 6px', fontSize: 12 }} />
        <div style={{ display: 'flex', gap: 4 }}>
          {JOURS_LABELS.map((label, i) => {
            const actif = joursArr[i] !== '_';
            return (
              <button key={i} onClick={() => toggleJour(i)} style={{
                width: 34, height: 26, borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer',
                background: actif ? '#1a56db' : 'white', color: actif ? 'white' : '#9ca3af',
                border: actif ? 'none' : '1px solid #e5e7eb',
              }}>{label}</button>
            );
          })}
        </div>
        {canDelete && (
          <button onClick={onDelete} style={{ marginLeft: 'auto', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, padding: '3px 6px', fontSize: 11, color: '#dc2626', cursor: 'pointer', display: 'flex', alignItems: 'center' }}><X size={10} /></button>
        )}
      </div>
    </div>
  );
}

function HorairesEditor({ porteId, plages, onChangePlages }) {
  const portePlages = plages[porteId] || [{ heure_debut: '00:00', heure_fin: '23:59', jours: 'LMMJVSD', ordre: 1 }];
  const updatePlage = (idx, newPlage) => {
    onChangePlages(porteId, portePlages.map((p, i) => i === idx ? newPlage : p));
  };
  const addPlage = () => {
    if (portePlages.length >= 4) return;
    onChangePlages(porteId, [...portePlages, { heure_debut: '00:00', heure_fin: '23:59', jours: 'LMMJVSD', ordre: portePlages.length + 1 }]);
  };
  const deletePlage = (idx) => {
    onChangePlages(porteId, portePlages.filter((_, i) => i !== idx).map((p, i) => ({ ...p, ordre: i + 1 })));
  };
  return (
    <div>
      {portePlages.map((p, idx) => (
        <PlageRow key={idx} plage={p} idx={idx} onUpdate={(np) => updatePlage(idx, np)} onDelete={() => deletePlage(idx)} canDelete={portePlages.length > 1} />
      ))}
      {portePlages.length < 4 && (
        <div onClick={addPlage} style={{ margin: '4px 0 4px 46px', padding: '6px 14px', fontSize: 12, color: '#1a56db', cursor: 'pointer', border: '1px dashed #bfdbfe', borderRadius: 8, textAlign: 'center', background: '#f8faff' }}>
          + Ajouter une plage horaire
        </div>
      )}
    </div>
  );
}

function ModalPorte({ porte, batId, etageId, onClose, onSave }) {
  const [form, setForm] = useState({
    nom: porte.nom || '',
    type: porte.type || 'porte',
    horaires: porte.horaires || '00:00-23:59',
    jours: porte.jours || 'LMMJVSD',
    statut: porte.statut || 'ferme',
    bluetooth_uuid: porte.bluetooth_uuid || '',
    require_validation: porte.require_validation || false,
    latitude: porte.latitude || '',
    longitude: porte.longitude || '',
    knx_group_address: porte.knx_group_address || '',
    knx_group_stop:    porte.knx_group_stop    || '',
  });
  const [gpsLoading, setGpsLoading] = useState(false);
  const joursArr = form.jours ? form.jours.split('') : ['L','M','M','J','V','S','D'];
  const JOURS_REF = ['L','M','M','J','V','S','D'];

  const toggleJour = (idx) => {
    const newJours = joursArr.map((j, i) => i === idx ? (j === '_' ? JOURS_REF[i] : '_') : j).join('');
    setForm(f => ({ ...f, jours: newJours }));
  };

  const detecterPosition = () => {
    if (!navigator.geolocation) return alert('Géolocalisation non supportée');
    setGpsLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setForm(f => ({ ...f, latitude: pos.coords.latitude.toFixed(6), longitude: pos.coords.longitude.toFixed(6) }));
        setGpsLoading(false);
      },
      () => { alert('Impossible d\'obtenir la position'); setGpsLoading(false); },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  const inp = { width: '100%', border: '1px solid var(--border)', borderRadius: 8, padding: '9px 12px', fontSize: 13, outline: 'none', marginTop: 6 };
  const lbl = { fontSize: 12, fontWeight: 500, color: '#374151', marginBottom: 4 };

  const handleSave = async () => {
    try {
      if (porte.id) {
        const updated = await api.updatePorte(batId, porte.id, form);
        onSave(updated);
      } else {
        const created = await api.addPorte(batId, { ...form, etage_id: etageId ?? null });
        onSave(created);
      }
      onClose();
    } catch (err) { alert(err.message); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: 'white', borderRadius: 14, padding: 28, width: 460, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 20 }}>Création / Modification Accès</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <div style={lbl}>Nom</div>
            <input style={inp} value={form.nom} onChange={e => setForm(f => ({ ...f, nom: e.target.value }))} />
          </div>
          <div>
            <div style={lbl}>Type</div>
            <select style={inp} value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))}>
              <optgroup label="Entrées"><option value="accueil">Accueil</option><option value="accueil_information">Accueil information</option><option value="entree">Entrée principale</option><option value="sortie">Sortie</option><option value="porte">Porte</option></optgroup>
              <optgroup label="Bâtiment"><option value="batiment">Bâtiment</option><option value="batiment_annexe">Bâtiment annexe</option><option value="maison">Maison</option><option value="ascenseur">Ascenseur</option><option value="escaliers">Escaliers</option></optgroup>
              <optgroup label="Espaces de vie"><option value="chambre">Chambre</option><option value="salon">Salon</option><option value="salle_bain">Salle de bain</option><option value="douche">Douche</option><option value="toilettes">Toilettes</option><option value="mobil_home">Mobil home</option><option value="emplacement">Emplacement</option><option value="lodge">Lodge</option><option value="tente">Tente</option><option value="place">Place</option></optgroup>
              <optgroup label="Restauration"><option value="cafeteria">Cafétéria</option><option value="restaurant">Restaurant</option><option value="cuisine">Cuisine</option><option value="distributeur_boisson">Distributeur boissons</option></optgroup>
              <optgroup label="Commerce & Logistique"><option value="boutique">Boutique</option><option value="commerce">Commerce / Retail</option><option value="archives">Archives</option><option value="entrepot">Entrepôt</option><option value="livraison">Livraison</option><option value="stockage">Stockage</option></optgroup>
              <optgroup label="Hygiène & Santé"><option value="infirmerie">Infirmerie</option><option value="laboratoire">Laboratoire</option><option value="pharmacie">Pharmacie</option></optgroup>
              <optgroup label="Véhicules"><option value="parking">Parking</option><option value="garage">Garage</option><option value="velo">Vélo</option></optgroup>
              <optgroup label="Sécurité"><option value="securite">PC Sécurité</option><option value="camera">Caméra</option><option value="badge">Badge</option><option value="acces">Accès</option></optgroup>
              <optgroup label="Bureaux"><option value="bureau">Bureau</option><option value="direction">Direction</option><option value="administration">Administration</option><option value="comptabilite">Comptabilité</option><option value="rh">Ressources humaines</option><option value="responsable">Responsable</option><option value="coworking">Coworking</option><option value="reunion">Salle de réunion</option><option value="formation">Formation</option></optgroup>
              <optgroup label="Informatique"><option value="informatique">Informatique</option><option value="impression">Impression</option><option value="reprographie">Reprographie</option><option value="serveur">Salle serveur</option></optgroup>
              <optgroup label="Technique & BTP"><option value="maintenance">Maintenance</option><option value="travaux">Travaux</option><option value="btp">BTP / Chantier</option><option value="electricite">Électricité</option><option value="incendie">Incendie</option><option value="temperature">Température</option><option value="eau">Eau</option></optgroup>
              <optgroup label="Loisirs & Événementiel"><option value="piscine">Piscine</option><option value="sport">Sport</option><option value="discotheque">Discothèque</option><option value="spa">Spa</option><option value="salle_reception">Salle de réception</option><option value="salle_jeux">Salle de jeux</option></optgroup>
            </select>
          </div>
          <div>
            <div style={lbl}>Statut</div>
            <select style={inp} value={form.statut} onChange={e => setForm(f => ({ ...f, statut: e.target.value }))}>
              <option value="ouvert">Ouvert</option>
              <option value="ferme">Fermé</option>
            </select>
          </div>
          <div>
            <div style={lbl}>Horaires d'ouverture</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6 }}>
              <input type="time" value={form.horaires.split('-')[0] || '00:00'}
                onChange={e => setForm(f => ({ ...f, horaires: e.target.value + '-' + (f.horaires.split('-')[1] || '23:59') }))}
                style={{ border: '1px solid var(--border)', borderRadius: 8, padding: '8px 10px', fontSize: 13 }} />
              <span style={{ color: '#6b7280' }}>→</span>
              <input type="time" value={form.horaires.split('-')[1] || '23:59'}
                onChange={e => setForm(f => ({ ...f, horaires: (f.horaires.split('-')[0] || '00:00') + '-' + e.target.value }))}
                style={{ border: '1px solid var(--border)', borderRadius: 8, padding: '8px 10px', fontSize: 13 }} />
            </div>
          </div>
          <div>
            <div style={lbl}>Jours d'accès</div>
            <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
              {JOURS_LABELS.map((label, idx) => {
                const actif = joursArr[idx] !== '_';
                return (
                  <button key={idx} onClick={() => toggleJour(idx)} style={{
                    flex: 1, height: 34, borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                    background: actif ? '#1a56db' : 'white',
                    color: actif ? 'white' : '#9ca3af',
                    border: actif ? 'none' : '1px solid #e5e7eb',
                  }}>{label}</button>
                );
              })}
            </div>
          </div>
          <div style={{ borderTop: '1px solid #f3f4f6', paddingTop: 14 }}>
            <div style={{ fontWeight: 600, fontSize: 13, color: '#7c3aed', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6 }}>🔌 KNX</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 6 }}>
              <div>
                <div style={lbl}>Adresse groupe (ouverture) <span style={{ fontWeight: 400, color: '#9ca3af' }}>ex : 1/0/1</span></div>
                <input style={inp} value={form.knx_group_address} placeholder="1/0/1"
                  onChange={e => setForm(f => ({ ...f, knx_group_address: e.target.value }))} />
              </div>
              <div>
                <div style={lbl}>Adresse groupe (stop/volet) <span style={{ fontWeight: 400, color: '#9ca3af' }}>optionnel</span></div>
                <input style={inp} value={form.knx_group_stop} placeholder="1/0/2"
                  onChange={e => setForm(f => ({ ...f, knx_group_stop: e.target.value }))} />
              </div>
            </div>
          </div>

          <div style={{ borderTop: '1px solid #f3f4f6', paddingTop: 14 }}>
            <div style={{ fontWeight: 600, fontSize: 13, color: '#1a1a2e', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6 }}><Bluetooth size={14} /> Bluetooth</div>
            <div>
              <div style={lbl}>UUID du beacon BLE <span style={{ fontWeight: 400, color: '#9ca3af' }}>(laisser vide si non configuré)</span></div>
              <input style={inp} value={form.bluetooth_uuid} placeholder="ex: 0000FFF0-0000-1000-8000-00805F9B34FB"
                onChange={e => setForm(f => ({ ...f, bluetooth_uuid: e.target.value }))} />
            </div>
            <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f9fafb', borderRadius: 8, padding: '10px 14px', border: '1px solid #e5e7eb' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500, color: '#374151' }}>Validation requise</div>
                <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>Si activé, l'employé doit appuyer sur un bouton. Sinon, ouverture automatique à ~50cm.</div>
              </div>
              <div onClick={() => setForm(f => ({ ...f, require_validation: !f.require_validation }))}
                style={{ width: 42, height: 24, borderRadius: 12, background: form.require_validation ? '#1a56db' : '#d1d5db', cursor: 'pointer', position: 'relative', transition: 'background 0.2s', flexShrink: 0, marginLeft: 16 }}>
                <div style={{ position: 'absolute', top: 3, left: form.require_validation ? 21 : 3, width: 18, height: 18, borderRadius: 9, background: 'white', transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: 12, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '10px 14px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <MapPin size={14} color="#16a34a" />
              <span style={{ fontSize: 13, fontWeight: 600, color: '#15803d' }}>Point GPS</span>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={detecterPosition} disabled={gpsLoading} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #86efac', background: 'white', color: '#16a34a', cursor: 'pointer', fontWeight: 500 }}>
                {gpsLoading ? 'Localisation...' : 'Ma position'}
              </button>
              {form.latitude && form.longitude && (
                <a href={`https://maps.google.com/?q=${form.latitude},${form.longitude}`} target="_blank" rel="noreferrer"
                  style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #86efac', background: '#16a34a', color: 'white', cursor: 'pointer', fontWeight: 500, textDecoration: 'none' }}>
                  Voir carte
                </a>
              )}
              {form.latitude && form.longitude && (
                <button onClick={() => setForm(f => ({ ...f, latitude: '', longitude: '' }))} style={{ fontSize: 11, padding: '4px 8px', borderRadius: 6, border: '1px solid #fca5a5', background: 'white', color: '#dc2626', cursor: 'pointer' }}>✕</button>
              )}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <input placeholder="Latitude (ex: 48.856614)" value={form.latitude} onChange={e => setForm(f => ({ ...f, latitude: e.target.value }))}
              style={{ flex: 1, border: '1px solid #bbf7d0', borderRadius: 6, padding: '6px 10px', fontSize: 12, outline: 'none', background: 'white' }} />
            <input placeholder="Longitude (ex: 2.352222)" value={form.longitude} onChange={e => setForm(f => ({ ...f, longitude: e.target.value }))}
              style={{ flex: 1, border: '1px solid #bbf7d0', borderRadius: 6, padding: '6px 10px', fontSize: 12, outline: 'none', background: 'white' }} />
          </div>
          {!form.latitude && !form.longitude && (
            <div style={{ fontSize: 11, color: '#86efac', marginTop: 6 }}>Optionnel — permet la navigation GPS depuis l'app mobile</div>
          )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 24 }}>
          <button onClick={onClose} style={{ padding: '8px 18px', borderRadius: 8, border: '1px solid var(--border)', background: 'white', cursor: 'pointer' }}>Annuler</button>
          <button onClick={handleSave} style={{ padding: '8px 18px', borderRadius: 8, border: 'none', background: 'var(--blue)', color: 'white', fontWeight: 500, cursor: 'pointer' }}>Enregistrer</button>
        </div>
      </div>
    </div>
  );
}

function PorteRow({ porte, batId, onUpdate, onDelete, selectedEmploye, accesEmploye, plages, onToggleAcces, onChangePlages, indented }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const coche = accesEmploye && accesEmploye.includes(porte.id);
  const { showConfirm, confirmModal } = useConfirm();

  const toggleStatut = async () => {
    setLoading(true);
    try {
      const newStatut = porte.statut === 'ouvert' ? 'ferme' : 'ouvert';
      const updated = await api.updatePorte(batId, porte.id, { statut: newStatut });
      onUpdate(updated);
    } catch (err) { alert(err.message); }
    setLoading(false);
  };

  const handleDelete = async () => {
    const ok = await showConfirm({
      title: 'SUPPRIMER CE POINT D\'ACCÈS',
      subtitle: porte.nom,
      body: 'Cette action est irréversible. Le point d\'accès et tous ses droits associés seront définitivement supprimés.',
      confirmLabel: 'Supprimer',
      confirmColor: '#dc2626',
      icon: Trash2,
    });
    if (!ok) return;
    try {
      await api.deletePorte(batId, porte.id);
      onDelete(porte.id);
    } catch (err) { alert(err.message); }
  };

  return (
    <div>
      {showModal && <ModalPorte porte={porte} batId={batId} onClose={() => setShowModal(false)} onSave={onUpdate} />}
      {confirmModal}
      <div style={{ display: 'flex', alignItems: 'center', padding: '14px 20px', borderBottom: '1px solid #f9fafb', gap: 14, paddingLeft: indented ? 32 : 20 }}>
        {selectedEmploye && (
          <input type="checkbox" checked={coche} onChange={() => onToggleAcces(porte.id)}
            style={{ cursor: 'pointer', width: 16, height: 16 }} />
        )}
        <div style={{ width: 36, height: 36, borderRadius: 10, background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <TypeIcon type={porte.type} size={18} color="#1a56db" />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#1a1a2e' }}>{porte.nom}</div>
          <div style={{ fontSize: 12, color: 'var(--gray)', marginTop: 2 }}>
            <span style={{ textTransform: 'capitalize' }}>{porte.type}</span>
            {porte.horaires && <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}> · <Clock size={11} /> {porte.horaires}</span>}
            {porte.jours && (() => {
              const nb = porte.jours.split('').filter(j => j !== '_').length;
              const label = nb === 7 ? '7j/7' : nb + 'j/sem';
              const color = nb === 7 ? 'var(--green)' : '#f59e0b';
              return <span style={{ color }}> · {label}</span>;
            })()}
          </div>
        </div>
        {!selectedEmploye && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: porte.statut === 'ouvert' ? '#00B050' : '#ef4444' }}>
              {porte.statut === 'ouvert' ? 'Ouvert' : 'Fermé'}
            </span>
            <div onClick={toggleStatut} style={{
              width: 40, height: 22, borderRadius: 11, cursor: loading ? 'wait' : 'pointer',
              background: porte.statut === 'ouvert' ? '#00B050' : '#ef4444',
              position: 'relative', transition: 'background 0.2s',
            }}>
              <div style={{
                position: 'absolute', top: 3, left: porte.statut === 'ouvert' ? 21 : 3,
                width: 16, height: 16, borderRadius: '50%', background: 'white',
                transition: 'left 0.2s',
              }} />
            </div>
            <button onClick={() => setShowModal(true)} title="Modifier" style={{ padding: '5px 8px', borderRadius: 6, border: '1px solid var(--border)', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center' }}><Pencil size={13} color="#374151" /></button>
            <button onClick={handleDelete} title="Supprimer" style={{ padding: '5px 8px', borderRadius: 6, border: '1px solid #fee2e2', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center' }}><Trash2 size={13} color="#dc2626" /></button>
          </div>
        )}
      </div>
      {selectedEmploye && coche && (
        <HorairesEditor porteId={porte.id} plages={plages} onChangePlages={onChangePlages} />
      )}
    </div>
  );
}

function EtageSection({ etage, portes, batId, onAddPorte, onUpdatePorte, onDeletePorte, onUpdateEtage, onDeleteEtage, selectedEmploye, accesEmploye, plages, onToggleAcces, onToggleEtage, onChangePlages }) {
  const [expanded, setExpanded] = useState(true);
  const [editingNom, setEditingNom] = useState(false);
  const [nomTemp, setNomTemp] = useState(etage.nom);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleRenommer = async () => {
    if (!nomTemp.trim()) return;
    try {
      await api.updateEtage(batId, etage.id, { nom: nomTemp });
      onUpdateEtage({ ...etage, nom: nomTemp });
      setEditingNom(false);
    } catch (err) { alert(err.message); }
  };

  const handleDelete = () => setConfirmDelete(true);
  const doDelete = async () => {
    setConfirmDelete(false);
    try {
      await api.deleteEtage(batId, etage.id);
      onDeleteEtage(etage.id);
    } catch (err) { alert(err.message); }
  };

  const tousCoches = portes.length > 0 && portes.every(p => accesEmploye && accesEmploye.includes(p.id));

  return (
    <div style={{ borderLeft: '3px solid #e2e8f0', marginLeft: 16, marginBottom: 4 }}>
      {confirmDelete && <ModalConfirmAcces
        title={`Supprimer l'étage`}
        body={`Supprimer "${etage.nom}"${portes.length > 0 ? ` et ses ${portes.length} point(s) d'accès` : ''} ?`}
        onConfirm={doDelete} onCancel={() => setConfirmDelete(false)} />}
      <div style={{ display: 'flex', alignItems: 'center', padding: '9px 16px', background: '#f8fafc', cursor: 'pointer', borderBottom: '1px solid #f1f5f9' }}
        onClick={() => setExpanded(v => !v)}>
        {selectedEmploye && (
          <input type="checkbox" checked={tousCoches}
            onChange={e => { e.stopPropagation(); onToggleEtage(portes); }}
            onClick={e => e.stopPropagation()}
            style={{ cursor: 'pointer', width: 16, height: 16, marginRight: 10 }} />
        )}
        {/rdc|rez/i.test(etage.nom)
          ? <Layers size={15} color="#6b7280" style={{ marginRight: 8, flexShrink: 0 }} />
          : <TrendingUp size={15} color="#6b7280" style={{ marginRight: 8, flexShrink: 0 }} />
        }
        {editingNom ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1 }} onClick={e => e.stopPropagation()}>
            <input value={nomTemp} onChange={e => setNomTemp(e.target.value)} autoFocus
              onKeyDown={e => { if (e.key === 'Enter') handleRenommer(); if (e.key === 'Escape') setEditingNom(false); }}
              style={{ border: '1.5px solid #1a56db', borderRadius: 6, padding: '3px 8px', fontSize: 13, outline: 'none', width: 200 }} />
            <button onClick={handleRenommer} style={{ background: '#1a56db', color: 'white', border: 'none', borderRadius: 6, padding: '3px 8px', fontSize: 11, cursor: 'pointer' }}>OK</button>
            <button onClick={() => setEditingNom(false)} style={{ background: 'white', color: '#6b7280', border: '1px solid #e5e7eb', borderRadius: 6, padding: '3px 6px', fontSize: 11, cursor: 'pointer', display: 'flex', alignItems: 'center' }}><X size={11} /></button>
          </div>
        ) : (
          <span style={{ fontSize: 13, fontWeight: 600, color: '#374151', flex: 1 }}>{etage.nom}</span>
        )}
        {!editingNom && !selectedEmploye && (
          <div style={{ display: 'flex', gap: 6, marginRight: 8 }} onClick={e => e.stopPropagation()}>
            <span style={{ fontSize: 11, color: '#9ca3af', marginRight: 4 }}>{portes.length} accès</span>
            <button onClick={() => setEditingNom(true)} title="Renommer" style={{ padding: '5px 8px', borderRadius: 6, border: '1px solid var(--border)', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center' }}><Pencil size={13} color="#374151" /></button>
            <button onClick={handleDelete} title="Supprimer" style={{ padding: '5px 8px', borderRadius: 6, border: '1px solid #fee2e2', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center' }}><Trash2 size={13} color="#dc2626" /></button>
          </div>
        )}
        {expanded ? <ChevronUp size={13} color="#9ca3af" /> : <ChevronDown size={13} color="#9ca3af" />}
      </div>
      {expanded && (
        <>
          {portes.map(p => (
            <PorteRow key={p.id} porte={p} batId={batId}
              onUpdate={onUpdatePorte} onDelete={onDeletePorte}
              selectedEmploye={selectedEmploye} accesEmploye={accesEmploye}
              plages={plages} onToggleAcces={onToggleAcces} onChangePlages={onChangePlages}
              indented />
          ))}
          {!selectedEmploye && (
            <div onClick={() => onAddPorte(etage.id)} style={{ padding: '9px 16px', textAlign: 'center', fontSize: 12, color: '#6b7280', cursor: 'pointer', borderTop: '1px dashed #e5e7eb', background: '#fafafa' }}>
              + Ajouter un point d'accès dans cet étage
            </div>
          )}
        </>
      )}
    </div>
  );
}

function BatimentCard({ bat, onChange, onDelete, selectedEmploye, accesEmploye, plages, onToggleAcces, onToggleBatiment, onToggleEtage, onChangePlages }) {
  const [expanded, setExpanded] = useState(true);
  const [editingNom, setEditingNom] = useState(false);
  const [nomTemp, setNomTemp] = useState(bat.nom);
  const [newPorteState, setNewPorteState] = useState(null);
  const [confirmDeleteBat, setConfirmDeleteBat] = useState(false);
  const [addEtageModal, setAddEtageModal] = useState(false);

  const etages = bat.etages || [];
  const portesParEtage = {};
  const portesDirectes = [];
  bat.portes.forEach(p => {
    if (p.etage_id) {
      if (!portesParEtage[p.etage_id]) portesParEtage[p.etage_id] = [];
      portesParEtage[p.etage_id].push(p);
    } else {
      portesDirectes.push(p);
    }
  });

  const handleDeleteBat = () => setConfirmDeleteBat(true);
  const doDeleteBat = async () => {
    setConfirmDeleteBat(false);
    try {
      await api.deleteBatiment(bat.id);
      onDelete(bat.id);
    } catch (err) { alert(err.message); }
  };

  const handleRenommerBat = async () => {
    if (!nomTemp.trim()) return;
    try {
      await api.updateBatiment(bat.id, { nom: nomTemp, adresse: bat.adresse });
      onChange({ ...bat, nom: nomTemp });
      setEditingNom(false);
    } catch (err) { alert(err.message); }
  };

  const handleAddEtage = () => setAddEtageModal(true);
  const doAddEtage = async (nom) => {
    setAddEtageModal(false);
    try {
      const etage = await api.addEtage(bat.id, { nom });
      onChange({ ...bat, etages: [...etages, etage] });
    } catch (err) { alert(err.message); }
  };

  const handleAddPorte = (etageId = null) => {
    setNewPorteState({ etageId });
  };

  const handleUpdateEtage = (updated) => {
    onChange({ ...bat, etages: etages.map(e => e.id === updated.id ? updated : e) });
  };

  const handleDeleteEtage = (etageId) => {
    onChange({ ...bat, etages: etages.filter(e => e.id !== etageId), portes: bat.portes.filter(p => p.etage_id !== etageId) });
  };

  const handleUpdatePorte = (updated) => {
    onChange({ ...bat, portes: bat.portes.map(p => p.id === updated.id ? updated : p) });
  };

  const handleDeletePorte = (porteId) => {
    onChange({ ...bat, portes: bat.portes.filter(p => p.id !== porteId) });
  };

  const ouverts = bat.portes.filter(p => p.statut === 'ouvert').length;
  const tousCoches = bat.portes.length > 0 && bat.portes.every(p => accesEmploye && accesEmploye.includes(p.id));

  return (
    <div style={{ background: 'white', borderRadius: 12, border: '1px solid var(--border)', marginBottom: 16, overflow: 'hidden' }}>
      {confirmDeleteBat && <ModalConfirmAcces
        title="Supprimer le bâtiment"
        body={`Supprimer "${bat.nom}" et tous ses points d'accès ? Cette action est irréversible.`}
        onConfirm={doDeleteBat} onCancel={() => setConfirmDeleteBat(false)} />}
      {addEtageModal && <ModalInput
        title="Ajouter un étage" icon={Layers}
        placeholder="ex: RDC, 1er étage, 2ème étage..."
        confirmLabel="Ajouter" onConfirm={doAddEtage} onCancel={() => setAddEtageModal(false)} />}
      {newPorteState && (
        <ModalPorte
          porte={{ type: 'porte', statut: 'ferme', horaires: '00:00-23:59', jours: 'LMMJVSD' }}
          batId={bat.id}
          etageId={newPorteState.etageId}
          onClose={() => setNewPorteState(null)}
          onSave={(p) => { onChange({ ...bat, portes: [...bat.portes, p] }); setNewPorteState(null); }}
        />
      )}
      <div style={{ display: 'flex', alignItems: 'center', padding: '16px 20px', cursor: 'pointer' }} onClick={() => setExpanded(v => !v)}>
        {selectedEmploye && (
          <input type="checkbox" checked={tousCoches}
            onChange={e => { e.stopPropagation(); onToggleBatiment(bat); }}
            onClick={e => e.stopPropagation()}
            style={{ cursor: 'pointer', width: 16, height: 16, marginRight: 10 }} />
        )}
        <div style={{ width: 40, height: 40, background: 'var(--blue-light)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 14 }}><Building2 size={20} color="#1a56db" /></div>
        <div style={{ flex: 1 }}>
          {editingNom ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }} onClick={e => e.stopPropagation()}>
              <input value={nomTemp} onChange={e => setNomTemp(e.target.value)} autoFocus
                onKeyDown={e => { if (e.key === 'Enter') handleRenommerBat(); if (e.key === 'Escape') setEditingNom(false); }}
                style={{ border: '1.5px solid #1a56db', borderRadius: 6, padding: '4px 8px', fontSize: 14, outline: 'none', width: 200 }} />
              <button onClick={handleRenommerBat} style={{ background: '#1a56db', color: 'white', border: 'none', borderRadius: 6, padding: '4px 8px', fontSize: 11, cursor: 'pointer' }}>OK</button>
              <button onClick={() => setEditingNom(false)} style={{ background: 'white', color: '#6b7280', border: '1px solid #e5e7eb', borderRadius: 6, padding: '4px 6px', fontSize: 11, cursor: 'pointer', display: 'flex', alignItems: 'center' }}><X size={11} /></button>
            </div>
          ) : (
            <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e' }}>{bat.nom}</div>
          )}
          <div style={{ fontSize: 12, color: 'var(--gray)', marginTop: 2 }}>{bat.adresse}</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {etages.length > 0 && <span style={{ fontSize: 12, color: 'var(--gray)' }}>{etages.length} étage{etages.length > 1 ? 's' : ''} ·</span>}
          <span style={{ fontSize: 12, color: 'var(--gray)' }}>{bat.portes.length} accès</span>
          {ouverts > 0 && !selectedEmploye && <span style={{ background: 'var(--green-light)', color: 'var(--green)', fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10 }}>{ouverts} ouverts</span>}
          {!selectedEmploye && <button onClick={e => { e.stopPropagation(); setEditingNom(true); }} title="Renommer" style={{ padding: '5px 8px', borderRadius: 6, border: '1px solid var(--border)', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center' }}><Pencil size={13} color="#374151" /></button>}
          {!selectedEmploye && <button onClick={e => { e.stopPropagation(); handleDeleteBat(); }} title="Supprimer" style={{ padding: '5px 8px', borderRadius: 6, border: '1px solid #fee2e2', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center' }}><Trash2 size={13} color="#dc2626" /></button>}
          {expanded ? <ChevronUp size={16} color="var(--gray)" /> : <ChevronDown size={16} color="var(--gray)" />}
        </div>
      </div>
      {expanded && (
        <>
          {etages.map(etage => (
            <EtageSection key={etage.id}
              etage={etage}
              portes={portesParEtage[etage.id] || []}
              batId={bat.id}
              onAddPorte={handleAddPorte}
              onUpdatePorte={handleUpdatePorte}
              onDeletePorte={handleDeletePorte}
              onUpdateEtage={handleUpdateEtage}
              onDeleteEtage={handleDeleteEtage}
              selectedEmploye={selectedEmploye}
              accesEmploye={accesEmploye}
              plages={plages}
              onToggleAcces={onToggleAcces}
              onToggleEtage={onToggleEtage}
              onChangePlages={onChangePlages}
            />
          ))}
          {portesDirectes.map(p => (
            <PorteRow key={p.id} porte={p} batId={bat.id}
              onUpdate={handleUpdatePorte} onDelete={handleDeletePorte}
              selectedEmploye={selectedEmploye} accesEmploye={accesEmploye}
              plages={plages} onToggleAcces={onToggleAcces} onChangePlages={onChangePlages} />
          ))}
          {!selectedEmploye && (
            <div style={{ borderTop: '1px dashed var(--border)', display: 'flex' }}>
              <div onClick={() => handleAddPorte(null)} style={{ flex: 1, padding: '12px 20px', textAlign: 'center', fontSize: 13, color: 'var(--blue)', cursor: 'pointer' }}>
                + Ajouter un point d'accès
              </div>
              <div style={{ width: 1, background: 'var(--border)' }} />
              <div onClick={handleAddEtage} style={{ flex: 1, padding: '12px 20px', textAlign: 'center', fontSize: 13, color: '#6b7280', cursor: 'pointer' }}>
                + Ajouter un étage
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default function Acces({ selectedEmploye, onClearSelectedEmploye }) {
  const [batiments, setBatiments] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [accesEmploye, setAccesEmploye] = useState([]);
  const [plages, setPlages] = useState({});

  useEffect(() => {
    api.getBatiments().then(setBatiments).catch(console.error).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (selectedEmploye) {
      api.request(selectedEmploye._type === 'client' ? `/clients/${selectedEmploye.id}/acces` : `/employes/${selectedEmploye.id}/acces`)
        .then(data => {
          const accesList = data.acces || data;
          setAccesEmploye(accesList.map(a => a.porte_id));
          const p = {};
          (data.plages || []).forEach(pl => {
            if (!p[pl.porte_id]) p[pl.porte_id] = [];
            p[pl.porte_id].push({ heure_debut: pl.heure_debut, heure_fin: pl.heure_fin, jours: pl.jours, ordre: pl.ordre });
          });
          setPlages(p);
        }).catch(() => {});
    } else {
      setAccesEmploye([]);
      setPlages({});
    }
  }, [selectedEmploye]);

  const saveAcces = async (newAcces, newPlages) => {
    if (!selectedEmploye) return;
    const isClient = selectedEmploye._type === 'client';
    const route = isClient ? `/clients/${selectedEmploye.id}/acces` : `/employes/${selectedEmploye.id}/acces`;
    const plagesArray = Object.entries(newPlages).flatMap(([porte_id, plages]) =>
      plages.map(p => ({ porte_id: Number(porte_id), heure_debut: p.heure_debut, heure_fin: p.heure_fin, jours: p.jours, ordre: p.ordre }))
    );
    await api.request(route, {
      method: 'POST',
      body: JSON.stringify({ porte_ids: newAcces, plages: plagesArray })
    }).catch(console.error);
  };

  const toggleAccesEmploye = async (porteId) => {
    const newAcces = accesEmploye.includes(porteId)
      ? accesEmploye.filter(id => id !== porteId)
      : [...accesEmploye, porteId];
    const newPlages = { ...plages };
    if (!newAcces.includes(porteId)) delete newPlages[porteId];
    else if (!newPlages[porteId]) newPlages[porteId] = [{ heure_debut: '00:00', heure_fin: '23:59', jours: 'LMMJVSD', ordre: 1 }];
    setAccesEmploye(newAcces);
    setPlages(newPlages);
    await saveAcces(newAcces, newPlages);
  };

  const toggleBatiment = async (bat) => {
    const porteIds = bat.portes.map(p => p.id);
    const tousCoches = porteIds.every(id => accesEmploye.includes(id));
    const newAcces = tousCoches
      ? accesEmploye.filter(id => !porteIds.includes(id))
      : [...new Set([...accesEmploye, ...porteIds])];
    const newPlages = { ...plages };
    if (tousCoches) porteIds.forEach(id => delete newPlages[id]);
    else porteIds.forEach(id => { if (!newPlages[id]) newPlages[id] = [{ heure_debut: '00:00', heure_fin: '23:59', jours: 'LMMJVSD', ordre: 1 }]; });
    setAccesEmploye(newAcces);
    setPlages(newPlages);
    await saveAcces(newAcces, newPlages);
  };

  const toggleEtage = async (etagePortes) => {
    const porteIds = etagePortes.map(p => p.id);
    const tousCoches = porteIds.every(id => accesEmploye.includes(id));
    const newAcces = tousCoches
      ? accesEmploye.filter(id => !porteIds.includes(id))
      : [...new Set([...accesEmploye, ...porteIds])];
    const newPlages = { ...plages };
    if (tousCoches) porteIds.forEach(id => delete newPlages[id]);
    else porteIds.forEach(id => { if (!newPlages[id]) newPlages[id] = [{ heure_debut: '00:00', heure_fin: '23:59', jours: 'LMMJVSD', ordre: 1 }]; });
    setAccesEmploye(newAcces);
    setPlages(newPlages);
    await saveAcces(newAcces, newPlages);
  };

  const handleChangePlages = async (porteId, newPortePlages) => {
    const newPlages = { ...plages, [porteId]: newPortePlages };
    setPlages(newPlages);
    await saveAcces(accesEmploye, newPlages);
  };

  const totalPortes  = batiments.reduce((s, b) => s + b.portes.length, 0);
  const totalOuverts = batiments.reduce((s, b) => s + b.portes.filter(p => p.statut === 'ouvert').length, 0);
  const totalFermes  = totalPortes - totalOuverts;
  const totalEtages  = batiments.reduce((s, b) => s + (b.etages || []).length, 0);

  const [addBatModal, setAddBatModal] = useState(false);
  const handleAddBatiment = () => setAddBatModal(true);
  const doAddBatiment = async (nom) => {
    setAddBatModal(false);
    try {
      const bat = await api.addBatiment({ nom, adresse: '' });
      setBatiments(prev => [...prev, bat]);
    } catch (err) { alert(err.message); }
  };

  if (loading) return <div style={{ padding: '28px 32px', color: 'var(--gray)', fontSize: 13 }}>Chargement...</div>;

  return (
    <div style={{ padding: '28px 32px' }}>
      {addBatModal && <ModalInput
        title="Ajouter un bâtiment" icon={Building2}
        placeholder="ex: Bâtiment principal, Villa, Annexe..."
        confirmLabel="Créer le bâtiment" onConfirm={doAddBatiment} onCancel={() => setAddBatModal(false)} />}
      {selectedEmploye && (
        <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12, padding: '14px 20px', marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#1a56db', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 600 }}>
              {selectedEmploye.initiales}
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#1a1a2e' }}>Accès de {selectedEmploye.denomination || selectedEmploye.service} — {selectedEmploye.nom}</div>
              <div style={{ fontSize: 12, color: '#6b7280', display: 'flex', alignItems: 'center', gap: 4 }}>
                <Check size={11} color="#16a34a" /> Modifications sauvegardées automatiquement
              </div>
            </div>
          </div>
          <button onClick={onClearSelectedEmploye} style={{ background: 'var(--green-light)', border: '1px solid var(--green)', borderRadius: 8, padding: '7px 14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600, color: 'var(--green)' }}>
            <Check size={14} /> Valider
          </button>
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 600 }}>Accès & zones</h1>
          <p style={{ fontSize: 13, color: 'var(--gray)', marginTop: 4 }}>{batiments.length} bâtiments · {totalEtages > 0 ? `${totalEtages} étages · ` : ''}{totalPortes} points d'accès</p>
        </div>
        {!selectedEmploye && (
          <button onClick={handleAddBatiment} style={{ background: 'var(--blue)', color: 'white', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>
            + Ajouter un bâtiment
          </button>
        )}
      </div>

      {!selectedEmploye && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
          <StatCard value={batiments.length} label="Bâtiments" color="#1a1a2e" />
          <StatCard value={totalPortes} label="Points d'accès" color="var(--blue)" />
          <StatCard value={totalOuverts} label="Accès ouverts" color="#00B050" />
          <StatCard value={totalFermes} label="Accès fermés" color="#ef4444" />
        </div>
      )}

      {batiments.map(bat => (
        <BatimentCard
          key={bat.id}
          bat={bat}
          onChange={updated => setBatiments(prev => prev.map(b => b.id === updated.id ? updated : b))}
          onDelete={id => setBatiments(prev => prev.filter(b => b.id !== id))}
          selectedEmploye={selectedEmploye}
          accesEmploye={accesEmploye}
          plages={plages}
          onToggleAcces={toggleAccesEmploye}
          onToggleBatiment={toggleBatiment}
          onToggleEtage={toggleEtage}
          onChangePlages={handleChangePlages}
        />
      ))}

      {batiments.length === 0 && (
        <div style={{ textAlign: 'center', padding: 48, color: 'var(--gray)', fontSize: 13 }}>
          Aucun bâtiment — cliquez sur "+ Ajouter un bâtiment" pour commencer
        </div>
      )}
    </div>
  );
}